module.exports = __webpack_public_path__ + "04fde32534296db2a7edae674b4be63d.svg";